// pls sort alphabetically by uri!
const uris = {
  about: '/about',
  blog: '/services',
  contact: '/contact',
  home: '/',
  solutions: '/solutions',
  crypto: '/crypto-portal',
  historicalData: '/historical-data',
  ourPartners: '/our-partners',
  partners: '/partners',
  privacyPolicy: '/privacy-policy',
  termsOfUse: '/terms-of-use',
  trading: '/copy-trading',
  strategies: '/trading-strategies',
  socialNewsApi: '/trader-news-api',
  technology: '/services',
  userStories: '/user-stories',
  external: {},
}

export default uris
